import dispatchCustomEvent from "../../../utils/dispatch-custom-event";
import createCustomEvent from "../../../utils/create-custom-event";
function updateLocationSideEffect() {
  var _window$NikeShop$get$;
  dispatchCustomEvent(createCustomEvent((_window$NikeShop$get$ = window.NikeShop.get().events) === null || _window$NikeShop$get$ === void 0 ? void 0 : _window$NikeShop$get$.locationUpdated, {
    bubbles: false
  }));
}
export default updateLocationSideEffect;